import React from 'react'
import { Link } from 'react-router'
import { CommonReference } from 'domain/DTO'
import { SRD } from 'srd'
import { SearchIcon } from '../icons'
import { API_HOST } from '../lib'
import { useRemoteData } from '../lib/RemoteData'
import { LoadingSpinner } from './LoadingSpinner'

export function CommonReferences({ commons }: { commons: Array<CommonReference> }) {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Installations</th>
        </tr>
      </thead>
      <tbody>
        {commons.map((common) => (
          <CommonRow key={common.commonId} common={common} />
        ))}
      </tbody>
    </table>
  )
}

function CommonRow({ common }: { common: CommonReference }) {
  const { data: installationCountRemoteData } = useRemoteData<number>(
    `${API_HOST}/v1/common/${common.commonId}/installations/count`,
  )

  const link = `/common-assortment/${common.commonId}`
  const installationsLink = `/installations?commonId=${common.commonId}`

  return (
    <tr className="even:bg-grey-light hover:bg-fog">
      <td>
        <Link to={link}>{`📑 ${common.name}`}</Link>
      </td>
      <td>
        <Link to={installationsLink}>
          {SRD.match(
            {
              notAsked: () => <LoadingSpinner />,
              loading: () => <LoadingSpinner />,
              failure: () => <div className="text-sm text-danger">Error</div>,
              success: (installationCount) => (
                <div className="inline-flex">
                  <span className="link mr-sm">{installationCount}</span>
                  <SearchIcon color="none" size="18" />
                </div>
              ),
            },
            installationCountRemoteData,
          )}
        </Link>
      </td>
    </tr>
  )
}
